(function () {
  'use strict';

  function getRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  async function refreshSlideCart() {
  var response = await fetch(
    '/?section_id=template-slide-out-cart'
  );

  if (!response.ok) {
    throw new Error('Unable to refresh the cart drawer');
  }

  var html = await response.text();
  var doc = new DOMParser().parseFromString(html, 'text/html');

  var newItems = doc.querySelector('[data-cart-items]');
  var currentItems = document.querySelector('[data-cart-items]');
  var newFooter = doc.querySelector('.slide-cart__footer');
  var currentFooter = document.querySelector('.slide-cart__footer');

  if (!newItems || !currentItems || !newFooter || !currentFooter) {
    throw new Error('Cart drawer markup is unavailable');
  }

  currentItems.innerHTML = newItems.innerHTML;
  currentFooter.innerHTML = newFooter.innerHTML;

  var cartResponse = await fetch(getRoot() + 'cart.js', {
    headers: {
      Accept: 'application/json'
    }
  });

  if (!cartResponse.ok) {
    throw new Error('Unable to load the updated cart');
  }

  var cart = await cartResponse.json();

  updateCartCount(cart.item_count);

  if (
    window.FreeShippingBar &&
    typeof window.FreeShippingBar.update === 'function'
  ) {
    window.FreeShippingBar.update(cart.total_price);
  }

  refreshCartUpsells(currentFooter);

  return cart;
}

  function refreshCartUpsells(root) {
    if (typeof window.remountSplidesIn === 'function') {
      window.remountSplidesIn(root);
    } else if (typeof window.refreshSplidesIn === 'function') {
      window.refreshSplidesIn(root);
    } else {
      return;
    }

    [80, 250, 500].forEach(function (delay) {
      window.setTimeout(function () {
        if (typeof window.refreshSplidesIn === 'function') {
          window.refreshSplidesIn(root);
        }
      }, delay);
    });
  }

  async function addVariantToCart(variantId) {
    var response = await fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity: 1
        }]
      })
    });

    var data = await response.json().catch(function () {
      return {};
    });

    if (!response.ok) {
      throw new Error(data.description || data.message || 'Add to cart failed');
    }

    return data;
  }

  // Move all modals to body on load so they escape any stacking contexts
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.quick-add-modal').forEach(function (modal) {
      document.body.appendChild(modal);
    });
  });

  // Slide-cart upsells add straight to cart. No quick-add modal.
document.addEventListener('click', async function (e) {
  var btn = e.target.closest(
    '.slide-cart__footer .quick-add-trigger'
  );

  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  if (btn.disabled) return;

  var variantId = btn.dataset.variantId;
  if (!variantId) return;

  var originalHtml = btn.innerHTML;

  btn.disabled = true;
  btn.textContent = 'Adding...';

  // This catch only handles a genuine Shopify add failure.
  try {
    await addVariantToCart(variantId);
  } catch (addError) {
    console.error('Slide-cart upsell add error:', addError);

    btn.textContent = 'Error - try again';

    window.setTimeout(function () {
      btn.innerHTML = originalHtml;
      btn.disabled = false;
    }, 2000);

    return;
  }

  // The item has been added. A drawer-refresh failure must not be
  // presented as an add failure because that encourages duplicates.
  try {
    await refreshSlideCart();

    if (typeof window.openSlideCart === 'function') {
      window.openSlideCart();
    }
  } catch (refreshError) {
    console.error(
      'Upsell added, but the cart drawer could not refresh:',
      refreshError
    );

    // Show Shopify's authoritative cart instead of stale drawer data.
    window.location.assign(getRoot() + 'cart');
  }
}, true);

  // Open modal
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.quick-add-trigger');
    if (!trigger) return;
    if (trigger.closest('.slide-cart__footer')) return;

    e.preventDefault();
    e.stopPropagation();

    var modal = document.getElementById('quick-add-' + trigger.dataset.productId);
    if (!modal) return;

    modal.removeAttribute('hidden');
    document.body.classList.add('quick-add-open');
  });

  // Close modal
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-modal-close]')) {
      e.preventDefault();
      e.stopPropagation();
      var modal = e.target.closest('.quick-add-modal');
      if (!modal) return;
      modal.setAttribute('hidden', '');
      document.body.classList.remove('quick-add-open');
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.quick-add-modal:not([hidden])');
      if (!open) return;
      open.setAttribute('hidden', '');
      document.body.classList.remove('quick-add-open');
    }
  });

  // Variant dropdown in the quick-add modal (only the gift cards have one).
  // Points the Add to Cart button at whichever option is chosen.
  function syncVariantSelect(select) {
    // A disabled dropdown means everything is sold out. Leave the SOLD OUT button alone.
    if (select.disabled) return;

    var modal = select.closest('.quick-add-modal');
    var btn = modal && modal.querySelector('.quick-add-atc-btn');
    if (!btn) return;

    var option = select.options[select.selectedIndex];

    if (!option || !option.value || option.disabled) {
      btn.dataset.variantId = '';
      btn.disabled = true;
      btn.textContent = btn.dataset.chooseLabel || btn.textContent;
      return;
    }

    btn.dataset.variantId = option.value;
    btn.disabled = false;
    btn.textContent = btn.dataset.addLabel || 'ADD TO CART';
  }

  document.addEventListener('change', function (e) {
    var select = e.target.closest ? e.target.closest('.quick-add-variant-select') : null;
    if (select) syncVariantSelect(select);
  });

  // The browser can restore a dropdown value on Back without firing change.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.quick-add-variant-select').forEach(syncVariantSelect);
  });

  // Add to cart from the quick-add modal
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick-add-atc-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    addVariantToCart(variantId)
      .then(function () {
        btn.textContent = 'Added!';
        return refreshSlideCart();
      })
      .then(function () {
        window.setTimeout(function () {
          var modal = btn.closest('.quick-add-modal');
          if (modal) modal.setAttribute('hidden', '');
          document.body.classList.remove('quick-add-open');
          btn.disabled = false;
          btn.textContent = originalText;
          if (typeof window.openSlideCart === 'function') window.openSlideCart();
        }, 900);
      })
      .catch(function (error) {
        console.error('Quick-add error:', error);
        btn.textContent = 'Error - try again';
        btn.disabled = false;
        window.setTimeout(function () {
          btn.textContent = originalText;
        }, 2000);
      });
  });
})();
